<template>
<v-layout alignt-start  >
  <v-container  grid-list-md  fluid wrap>
    
    <v-layout row>
      <v-flex xs6 order-lg2>
        <v-card dark tile flat>
          <v-card-text class="px-10">Picture to Save<Gallery /></v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs6>
        <v-card dark tile flat >
          <v-card-text  class="px-10">Camara<Camara v-on:takePicture="this.takePicture" /> </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
     </v-container>
  </v-layout>
</template>



<script>
    import Camara from './Camara';
    import Gallery from './Gallery';

    export default {
        
        name: 'GetPicture',
        
        components: {
            Camara,
            Gallery
        }, 
        props: ['imgBase64'],  
       
       created: function () {
            console.log('user data from parent component:')
            console.log(this.imgBase64) //prints out an empty string
        },
        
        methods: {
            takePicture () {
                let ratio = (window.innerHeight < window.innerWidth) ? 16 / 9 : 9 / 16;
                const picture = document.querySelector("canvas");
                picture.width = (window.innerWidth < 1280 ) ? window.innerWidth : 1280;
                picture.height =  window.innerHeight / ratio;
                const ctx = picture.getContext("2d");
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = "high";
                ctx.drawImage(document.querySelector("video"), 0, 0, picture.width, picture.height);
                //this.myImg64 = picture.toDataURL('image/png');
                this.$emit('clicked',picture.toDataURL('image/png'));
                //this.imgBase64 = picture.toDataURL('image/png');        
                //console.log(picture.toDataURL('image/png'));
                
               
            }
        }
    }
</script>

<style lang="scss">
    body {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        margin: 0;
        padding: 0;
        background-color: #F3F3F3;
    }
</style>